import XHR from 'bpm-xhr';


let contentWrapper = null;

class PageController {

	constructor() {
		this.page = {};
		this.active = null;
	}

	get contentWrapper() {
		return contentWrapper;
	}

	set contentWrapper(el) {
		contentWrapper = el;
		return true;
	}

	fetch(index) {
		return new Promise((resolve) => {
			new XHR('text')
				.get(`/${index}.html`)
				.then((xhr) => resolve(xhr.response));
		});
	}

	render(index, html) {
		const div = document.createElement('div');
		div.setAttribute('data-chapter', index);
		div.innerHTML = html;
		this.contentWrapper.appendChild(div);
		return div;
	}

	open(index) {
		this.active = index;
		return new Promise((resolve) => {
			this.fetch(index).then((html) => {
				if (index === this.active) {
					this.page[index] = this.render(index, html);
					resolve(this.page[index]);
				}
			});
		});
	}

	close(index = this.active) {
		if (this.page[index]) {
			this.page[index].remove();
			delete this.page[index];
		}
	}

}

export default new PageController();
